<template>
  <div class="wizard-container" :class="{ desktop: $isDesktop }">
    <div id="search-wizard-portal" />
    <section class="search-form">
      <slot />
    </section>
  </div>
</template>
<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({})
class WizardContainer extends Vue {}

export default toNative(WizardContainer)
</script>

<style scoped>
.wizard-container {
  position: relative;
  height: 100%;
  z-index: 11;
  width: 100vw;
  margin: 0;
}

[data-menu-open='true'] .homepage-search-input,
.account-open .homepage-search-input {
  z-index: 1;
}

.search-form {
  position: relative;
  height: auto;
}

.search-form {
  padding: 1.4em;
  background: linear-gradient(white, #f1f0f4 15%);
}

.search-edit .search-form {
  min-height: 100vh;
}

.wizard-container :deep(.modal) {
  background-color: #fff;
  border-radius: 0.6em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  height: auto;
  max-height: calc(100% - 4vw);
  margin: 2vw;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  width: 96vw;
  z-index: 13;
}

.wizard-container.check-availability .search-form {
  background-color: #fff;
  border-radius: 0.6em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 2vw;
  min-height: calc(100% - 4vw);
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  width: 96vw;
  z-index: 13;
  padding: 1.4em;
  background: linear-gradient(white, #f1f0f4 15%);
  height: auto;
}

.wizard-container.search-step-open:after {
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  content: '';
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 12;
}

/* desktop & tablet */
.wizard-container.desktop {
  width: 100%;
}

.wizard-container.desktop :deep(.modal) {
  border-radius: 1em;
  left: 0;
  margin: auto;
  max-height: none;
  max-width: 30em;
  padding: 2em;
  position: absolute;
  top: 0;
  width: auto;
}

.wizard-container.desktop :deep(.modal:has(.date-picker.date-picker-months-2)) {
  max-width: 60em;
  width: 60em;
  padding: 2em 1em;
}

.search-results-section
  .wizard-container.desktop
  :deep(.modal:has(.date-picker.date-picker-months-2)) {
  margin-left: 5em;
}

.wizard-container.desktop :deep(.modal footer) {
  margin: 1em 0;
  overflow: unset;
}
</style>
